export * from '@primeuix/themes/lara/iftalabel';
export { default } from '@primeuix/themes/lara/iftalabel';
